import CartEmptyNew from './CartEmptyNew'

export default CartEmptyNew
